import React, { Component } from "react";
import "./bulk-upload.styles.css";
import { selectUserData } from "../../redux/user/user.selectors";
import {
  Spin,
  Button,
  Typography,
  Row,
  Col,
  Card,
  Icon,
  Badge,
  Divider,
} from "antd";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter, Switch as RouteSwitch } from "react-router-dom";

import dashboard from "../../assets/dashboard.svg";
import receipt_long from "../../assets/receipt_long.svg";
import timer from "../../assets/timer.svg";
import mark_email_read from "../../assets/mark_email_read.svg";
import insights from "../../assets/insights.svg";

import {
  setScreenName,
  setScreenType,
} from "../../redux/arrival-entry/arrival-entry.actions";
import {
  selectBranchName,
  selectEntryNo,
  selectScreenName,
  selectScreenType,
  selectUploadFile,
} from "../../redux/arrival-entry/arrival-entry.selectors";
import moment from "moment";

/**
 * @component
 * @description The parent component for bulk upload page.
 *
 *
 */
class BulkUploadSuccess extends Component {
  state = {
    isSpinnerOn: false,
    isSubmitted: false,
  };

  render() {
    const { setScreenName, validEntry, branchName } = this.props;

    return (
      <Spin spinning={this.state.isSpinnerOn} tip="Loading...">
        <div className="success-page-container">
          <Row gutter={[32, 32]} style={{ marginBottom: 10 }}>
            <Col span={8}>
              <Card
                style={{
                  textAlign: "center",
                  marginBottom: 20,
                }}
              >
                <div className="animat-div">
                  <Icon
                    type="check-circle"
                    theme="filled"
                    className="iconinfo"
                    style={{ marginBottom: 30 }}
                  />
                </div>
                <Typography.Title style={{ fontWeight: 700 }}>
                  Upload Successful
                </Typography.Title>
                <Typography.Text style={{ fontSize: 18 }}>
                  Your dataset has been securely uploaded and is ready for
                  analysis.
                </Typography.Text>
              </Card>
              <Card
                style={{
                  padding: 0,
                  color: "#fff",
                  background: "#002045",
                  borderLeft: "10px solid #66affe",
                }}
              >
                <Row>
                  <Col span={4}>
                    <span>
                      <img
                        src={mark_email_read}
                        alt="info"
                        style={{ width: 50, height: 50, padding: 5 }}
                      />
                    </span>
                  </Col>
                  <Col span={20}>
                    <Typography.Text
                      style={{ fontWeight: 700, color: "#d2e4ff" }}
                    >
                      Confirmation Sent
                    </Typography.Text>
                    <br />
                    <Typography.Text style={{ color: "#d2e4ff" }}>
                      An email summary has been sent to your registered address.
                    </Typography.Text>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col span={16}>
              <Row gutter={[24, 24]}>
                <Col span={12}>
                  <Card style={{ minHeight: "67vh" }}>
                    <Typography.Text strong style={{ marginBottom: 40 }}>
                      <span style={{ paddingRight: 10 }}>
                        <img src={receipt_long} alt="info" />
                      </span>
                      TRANSACTION SUMMARY
                    </Typography.Text>
                    <Divider
                      style={{
                        background: "transparent",
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography.Text
                        style={{ fontWeight: 600, opacity: 0.9 }}
                      >
                        <Icon
                          type="environment"
                          style={{
                            fontSize: 18,
                            color: "#0061a5",
                            paddingRight: 10,
                            opacity: 1,
                            fontWeight: 700,
                          }}
                        />{" "}
                        Branch Name
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          textAlign: "right",
                          fontWeight: 700,
                          color: "#002045",
                        }}
                      >
                        {branchName}
                      </Typography.Text>
                    </div>
                    <Divider style={{ marginBottom: 40 }} />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography.Text
                        style={{ fontWeight: 600, opacity: 0.9 }}
                      >
                        <Icon
                          type="calendar"
                          style={{
                            fontSize: 18,
                            color: "#0061a5",
                            paddingRight: 10,
                            opacity: 1,
                            fontWeight: 700,
                          }}
                        />{" "}
                        Upload Date
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          textAlign: "right",
                          fontWeight: 700,
                          color: "#002045",
                        }}
                      >
                        {moment().format("MMMM DD, YYYY")}
                      </Typography.Text>
                    </div>
                    <Divider style={{ marginBottom: 40 }} />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography.Text
                        style={{ fontWeight: 600, opacity: 0.9 }}
                      >
                        <strong
                          style={{
                            color: "#0061a5",
                            fontSize: 18,
                            paddingRight: 10,
                            opacity: 1,
                            fontWeight: 700,
                          }}
                        >
                          {"{ }"}{" "}
                        </strong>
                        Total Records
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          textAlign: "right",
                          fontWeight: 700,
                          color: "#002045",
                        }}
                      >
                        {validEntry} entries
                      </Typography.Text>
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card style={{ background: "#f1f4f8", minHeight: "67vh" }}>
                    <span style={{ paddingRight: 10 }}>
                      <img
                        src={insights}
                        alt="info"
                        style={{
                          width: 60,
                          height: 60,
                          padding: 15,
                          background: "#d2e4ff",
                        }}
                      />
                    </span>
                    <Typography.Title level={3} style={{ marginTop: 20 }}>
                      System Processing
                    </Typography.Title>
                    <Typography.Paragraph>
                      Your data is currently being indexed for the{" "}
                      <strong>Market Snapshot</strong> reports. Professional
                      analytics and trend visualisations will be ready shortly.
                    </Typography.Paragraph>
                    <Card
                      style={{
                        background: "#fafbfd",
                        border: 0,
                        borderRadius: 0,
                        padding: 0,
                        marginTop: 20,
                      }}
                      bodyStyle={{ padding: 15 }}
                    >
                      <Typography.Text
                        strong
                        style={{ fontSize: 12, fontWeight: 700 }}
                      >
                        <span style={{ paddingRight: 10 }}>
                          <img src={timer} alt="info" />
                        </span>
                        Availble in ~15 minutes
                      </Typography.Text>
                    </Card>
                    <Divider />
                    <Typography.Text style={{ fontStyle: "italic" }}>
                      <Badge color={"green"} />
                      System health: Optimal Performance
                    </Typography.Text>
                  </Card>
                </Col>
                <Col span={16}>
                  <Button
                    style={{ width: "100%", height: "20vh", borderRadius: 10 }}
                    onClick={() => setScreenName(1)}
                  >
                    <Typography.Title level={4} style={{ color: "#fff" }}>
                      <span style={{ paddingRight: 10, color: "#fff" }}>
                        <img src={dashboard} alt="info" className="btn-icon" />
                      </span>
                      Return to Operational Dashboard
                    </Typography.Title>
                  </Button>
                </Col>
                <Col span={8}>
                  <Card
                    style={{
                      padding: 0,
                      background: "#f1f4f8",
                    }}
                    bodyStyle={{ paddingBlock: 20 }}
                  >
                    <Typography.Text style={{ fontWeight: 700 }}>
                      <Icon
                        type="info-circle"
                        style={{
                          fontSize: 18,
                          color: "#0061a5",
                          paddingRight: 10,
                        }}
                      />
                      Quota Alert
                    </Typography.Text>
                    <br />
                    <Typography.Text style={{ fontSize: 13 }}>
                      Today's submission limit is exhausted. Next upload window
                      opens tomorrow at 08:00 AM.
                    </Typography.Text>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setScreenName: (screenName) => dispatch(setScreenName(screenName)),
    setScreenType: (type) => dispatch(setScreenType(type)),
  };
};

const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  screenName: selectScreenName,
  screenType: selectScreenType,
  branchName: selectBranchName,
  validEntry: selectEntryNo,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BulkUploadSuccess),
);
